<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <el-select v-model="queryForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="关联订单">
                  <el-input v-model="queryForm.purchaseOrderNo" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="确认状态">
                  <el-select v-model="queryForm.confirmedStatus" clearable>
                    <el-option label="未确认" :value="0"></el-option>
                    <el-option label="已确认" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算状态">
                  <el-select v-model="queryForm.settlementStatus" clearable>
                    <el-option label="待结算" :value="0"></el-option>
                    <el-option label="待付款" :value="1"></el-option>
                    <el-option label="已结算" :value="2"></el-option>
                    <el-option label="无需结算" :value="-1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算单号">
                  <el-input v-model="queryForm.settlementOrderNo" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button type="primary" :disabled="selection.length == 0" @click="batchConfirm">确认金额</el-button>
      <div>
        <el-button type="primary" icon="el-icon-download" @click="exportData" :loading="exporting">导出</el-button>
        <span class="ml20" v-if="exportFileName">上一次导出结果：<el-link type="primary" @click="downloadExportResult">{{ exportFileName }}</el-link></span>
        <span class="ml20 red" v-if="exportFailed">导出失败</span>
      </div>
    </div>

    <el-table :data="tableData" @selection-change="tableSelectionChange">
      <el-table-column type="selection" width="55" :selectable="selectable">

      </el-table-column>
      <el-table-column prop="vendorAliasName" label="买手店别名"></el-table-column>
      <el-table-column prop="purchaseOrderNo" label="关联订单号"></el-table-column>
      <el-table-column prop="settlementOrderNo" label="结算单号"></el-table-column>
      <el-table-column prop="amount" label="金额">
        <template slot-scope="scope">
          <div class="item-cell" v-if="!scope.row.isEdit" @click="onClickAmount(scope.$index, $event)">{{ scope.row.amount }}&nbsp;</div>
          <el-input v-else type="number" v-model="scope.row.editAmount" @click.native="$event.stopPropagation()" @blur="onBlurAmount(scope.$index, $event)" :min="0" :max="9999999999"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="compensationAmountUnit" label="币别"></el-table-column>
      <el-table-column prop="paymentDescription" label="款项说明"></el-table-column>
      <el-table-column prop="settlementTimestamp" label="账期日期">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.settlementTimestamp) }}
        </template>
      </el-table-column>
      <el-table-column prop="createdTimestamp" label="创建日期">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdTimestamp) }}
        </template>
      </el-table-column>
      <el-table-column prop="confirmedStatus" label="确认状态">
        <template slot-scope="scope">
          <span v-if="scope.row.confirmedStatus === 0">未确认</span>
          <span v-if="scope.row.confirmedStatus === 1">已确认</span>
        </template>
      </el-table-column>
      <el-table-column prop="settlementStatus" label="结算状态">
        <template slot-scope="scope">
          <span v-if="scope.row.settlementStatus === 0">待结算</span>
          <span v-if="scope.row.settlementStatus === 1">待付款</span>
          <span v-if="scope.row.settlementStatus === 2">已结算</span>
          <span v-if="scope.row.settlementStatus === -1">无需结算</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.confirmedStatus === 0" @click="removeItem(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import utils from '@/utils/util';
import { downloadUrlFile } from '@/utils/functions';
import {
  getNotOrderSettlementSaleOrderList,
  updateAmount,
  confirmSettlementSaleOrder,
  delSettlementSaleOrder,
  exportNotOrderSettlement,
  exportNotOrderSettlementResult,
} from "./api";
import {
  queryVendorList,
} from "../../../api/mapping_cn";

export default {
  components: {
  },
  data() {
    return {
      vendorList: [],
      queryForm: {
        vendorId: null,
        purchaseOrderNo: null,
        confirmedStatus: null,
        settlementStatus: null,
        settlementOrderNo: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      selection: [],
      exporting: false,
      exportFileName: '',
      exportFailed: false,
    };
  },
  created() {
    queryVendorList().then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data;
      }
    });
    this.getTableData();
  },
  mounted() {
    window.addEventListener("click", this.onClickPage);
    this.getExportResult();
  },
  beforeDestroy() {
    window.removeEventListener("click", this.onClickPage);
  },
  methods: {
    selectable(row,index){
     return row.settlementStatus == -1?false:true;

    },
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorId = null;
      this.queryForm.purchaseOrderNo = null;
      this.queryForm.confirmedStatus = null;
      this.queryForm.settlementStatus = null;
      this.queryForm.settlementOrderNo = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    exportData() {
      this.queryForm.pageNo = 1;
      this.exportTabData();
    },
    exportTabData(){
      exportNotOrderSettlement(this.queryForm).then(res => {
        if (res.data.success) {
          this.getExportResult();
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      })
    },
    getExportResult() {
      exportNotOrderSettlementResult().then((res) => {
        if (res.data.code === '0') {
          this.exporting = true;
          this.exportFileName = '';
          this.exportFailed = false;
          this.exportTimer = setTimeout(() => {
            this.getExportResult();
          }, 2000);
        } else if (res.data.code === '1') {
          this.exporting = false;
          const data = JSON.parse(res.data.data);
          this.exportFileName = data.fileName;
          this.exportFileUrl = data.fileUrl;
          this.exportFailed = false;
          if (this.exportTimer) {
            clearTimeout(this.exportTimer);
          }
        } else if (res.data.code === '2') {
          this.exporting = false;
          this.exportFileName = '';
          this.exportFailed = true;
          if (this.exportTimer) {
            clearTimeout(this.exportTimer);
          }
        } else {
          this.exporting = false;
          this.exportFileName = '';
          this.exportFailed = false;
        }
      });
    },
    downloadExportResult() {
      downloadUrlFile(this.exportFileUrl);
    },
    getTableData() {
      getNotOrderSettlementSaleOrderList(this.queryForm).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = (res.data.data.list || []).map(item => ({
            ...item,
            isEdit: false,
            editAmount: item.amount,
          }));
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    tableSelectionChange(selection) {
      this.selection = selection;
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    onClickPage() {
      this.tableData.forEach((item) => {
        item.isEdit = false;
      });
    },
    onClickAmount(index, event) {
      event.stopPropagation();
      if (this.tableData[index].confirmedStatus !== 0) {
        return;
      }
      this.tableData.forEach((item, rowIndex) => {
        if (rowIndex === index) {
          item.isEdit = true;
        } else {
          item.isEdit = false;
        }
      });
    },
    onBlurAmount(index) {
      const row = this.tableData[index];
      if (row.editAmount == row.amount) {
        this.tableData[index].isEdit = false;
        return;
      }
      // 修改只能改为负数
      if (row.editAmount >= 0) {
        this.tableData[index].isEdit = false;
        row.editAmount = row.amount;
        return;
      }
      updateAmount({
        purchaseOrderNo: row.purchaseOrderNo,
        compensationAmount: row.editAmount,
      }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('修改成功');
          this.tableData[index].amount = row.editAmount;
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
          this.tableData[index].isEdit = true;
        }
      }).catch(() => {
        this.tableData[index].isEdit = true;
      })
    },
    batchConfirm() {
      if (this.selection.length === 0) {
        return;
      }
      if (this.selection.some(item => item.confirmedStatus !== 0)) {
        this.$message('只能选择待确认条目');
        return;
      }
      this.$confirm(`确认后金额无法修改，是否要确认?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        confirmSettlementSaleOrder({
          purchaseOrderNoList: this.selection.map(item => item.purchaseOrderNo),
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('确认成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        })
      })
    },
    removeItem(row) {
      this.$confirm(`确认删除吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delSettlementSaleOrder({
          purchaseOrderNo: row.purchaseOrderNo,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.message || '操作成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        })
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.store-wrap {
  max-height: 500px;
  overflow: auto;
}
.ml20 {
  margin-left: 20px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
}
.store-list {
  display: flex;
  margin-bottom: 2px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  .store-name {
    flex: 0 0 auto;
    width: 150px;
    padding: 10px;
    border-right: 1px solid #DCDFE6;
  }
  .store-stocklocation-list {
    padding: 10px;
  }
}
.sl-group {
  display: flex;
  flex-wrap: wrap;

  .sl-item {
    margin-right: 10px;
    margin-top: 10px;
    padding: 0 5px;
    line-height: 30px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .icon-close:hover {
    color: #409EFF;
  }
}
.vendor-name {
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow:hidden;
}
.item-cell:active {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
